module.exports = __webpack_public_path__ + "static/education-cicada-6b055eb9abf64163a1d52cbf478abedd.png";